import { useEffect, useState } from 'react';

type IconSplitText = {
	type: 'string' | 'icon',
	value: string
}

interface IconTextProps {
	text: string
}

function IconText({text}: IconTextProps) {
	const [splitArr, setSplitArr] = useState<IconSplitText[]>([])

	useEffect(() => {
		let arrHolder: IconSplitText[] = []
		let splitText: string[] = text.split('[[')

		splitText.forEach((txt: string) => {
			if (txt.includes(']]')) {
				let tempSplit: string[] = txt.split(']]')
				arrHolder.push({
					type: 'icon',
					value: tempSplit[0]
				})
				if (tempSplit[1]) {
					arrHolder.push({
						type: 'string',
						value: tempSplit[1]
					})
				}
			} else {
				arrHolder.push({
					type: 'string',
					value: txt
				})
			}
		})
		setSplitArr(arrHolder)
	}, [text])

	return (
		<>
			{splitArr.map((splitText: IconSplitText, index: number) =>
				splitText.type === 'string' ? 
					<span key={`iconText${index}`}>
						{splitText.value}
					</span>
					:
					<img 
						src={`/imgs/icons/${splitText.value}.svg`} 
						alt={splitText.value} 
						key={`iconText${index}`} 
					/>
			)}
		</>
	)
}

export default IconText
